import { ContentContext } from "components/layout/Main";
import { useContext, useLayoutEffect, useMemo } from "react";

export const useContentHeader = (initialHeader) => {
  const { header, setHeader } = useContext(ContentContext);

  useLayoutEffect(() => {
    if (initialHeader) setHeader(initialHeader);
    return () => setHeader();
  }, [initialHeader, setHeader]);

  return useMemo(() => [header, setHeader], [header, setHeader]);
};

export const useContentFooter = (initialFooter) => {
  const { footer, setFooter } = useContext(ContentContext);

  useLayoutEffect(() => {
    if (initialFooter) setFooter(initialFooter);
    return () => setFooter();
  }, [initialFooter, setFooter]);

  return useMemo(() => [footer, setFooter], [footer, setFooter]);
};
